<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">

        <div class="box citic-box">
          <el-tabs
            v-model="tabSelected"
            @tab-click="handleTabClicked">
            <el-tab-pane
              v-for="item in status"
              :key="item.name"
              :label="item.label"
              :name="item.name">
              <span slot="label">
                {{item.label}}
                <sup v-show="item.counter > 0">{{item.counter}}</sup>
              </span>
              <ReviewList
                :status="item.name"
                :is-activated="tabSelected === item.name"></ReviewList>
            </el-tab-pane>
          </el-tabs>
        </div>
        
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
// import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
import ReviewList from './List'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox,
    ReviewList
  },
  props: ['tab'],
  data () {
    return {
      shouldShowCreateForm: false,
      tabSelected: null
    }
  },
  computed: {
    moduleDef () {
      return this.$config.MODULES.reviews
    },
    status () {
      return this.$config.MODULES.reviews.status
    }
  },
  methods: {
    handleTabClicked () {
      //
    }
  },
  watch: {
    $route () {
      if (this.$route.params.tab === 'manage') {
        this.tabSelected = 'stored'
      } else if (this.$route.params.tab === 'pending') {
        this.tabSelected = 'pending'
      } else {
        this.tabSelected = 'analysis'
      }
    }
  },
  mounted () {
    if (this.tab === 'manage') {
      this.tabSelected = 'stored'
    } else if (this.tab === 'pending') {
      this.tabSelected = 'pending'
    } else {
      this.tabSelected = 'analysis'
    }
  }
}
</script>
<style lang="scss">
  .citic-box {
    padding-top: 15px;
    .el-tabs__content {
      overflow: visible !important;
      position: static;
    }
    .box-header {
      ul.nav-tabs {
        margin-bottom: 0 !important;
        border-bottom: 0;
        li > a {
          color: #9ebbcd !important;
        }
        li.active > a {
          color: #333 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?0a83dfde